export const LOG_OPTIONS_EMAIL = [
  "id",
  "name",
  "email",
  "subject",
  "customs",
  "status",
  "error",
  "createdAt",
];
